import React, { useState } from "react";
import { IPlayer, ITellInput, Storage } from "./storage";

export function AddTell() {
  const [players] = useState<IPlayer[]>(Storage.getPlayers());
  const [behaviors] = useState(Storage.getBehaviors());
  const [results] = useState(Storage.getResults());

  const [selectedPlayerId, setSelectedPlayerId] = useState<string | null>(null);
  const [selectedBehaviors, setSelectedBehaviors] = useState<string[]>([]);
  const [selectedResults, setSelectedResults] = useState<string[]>([]);
  const [comment, setComment] = useState("");
  const [preview, setPreview] = useState<ITellInput | null>(null);

  const toggleSelection = (id: string, list: string[], setList: React.Dispatch<React.SetStateAction<string[]>>) => {
    setList(list.includes(id) ? list.filter((item) => item !== id) : [...list, id]);
  };

  const handlePreview = () => {
    if (!selectedPlayerId || selectedBehaviors.length === 0 || selectedResults.length === 0) {
      alert("Please select a player, at least one behavior, and at least one result.");
      return;
    }

    const newTell: ITellInput = {
      playerId: selectedPlayerId,
      behaviorIds: selectedBehaviors,
      results: selectedResults,
      comment,
      createdAt: new Date(),
    };

    setPreview(newTell);
  };

  const handleSave = () => {
    if (!preview) return;

    Storage.addTell(preview);
    alert("Tell saved successfully!");
    setSelectedPlayerId(null);
    setSelectedBehaviors([]);
    setSelectedResults([]);
    setComment("");
    setPreview(null);
  };

  return (
    <div>
      <h1>Add Tell</h1>
      <div>
        <h2>Choose Player</h2>
        <select
          value={selectedPlayerId || ""}
          onChange={(e) => setSelectedPlayerId(e.target.value)}
        >
          <option value="" disabled>
            Select Player
          </option>
          {players.map((player) => (
            <option key={player.id} value={player.id}>
              {player.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <h2>Choose Behaviors</h2>
        {behaviors.map((behavior) => (
          <label key={behavior.id}>
            <input
              type="checkbox"
              checked={selectedBehaviors.includes(behavior.id)}
              onChange={() => toggleSelection(behavior.id, selectedBehaviors, setSelectedBehaviors)}
            />
            {behavior.name} {behavior.icon}
          </label>
        ))}
      </div>

      <div>
        <h2>Choose Results</h2>
        {results.map((result) => (
          <label key={result.id}>
            <input
              type="checkbox"
              checked={selectedResults.includes(result.id)}
              onChange={() => toggleSelection(result.id, selectedResults, setSelectedResults)}
            />
            {result.name} {result.icon}
          </label>
        ))}
      </div>

      <div>
        <h2>Comment</h2>
        <textarea
          placeholder="Add a comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </div>

      <div>
        <button onClick={handlePreview}>Preview</button>
        <button onClick={handleSave} disabled={!preview}>
          Save
        </button>
      </div>

      {preview && (
        <div>
          <h2>Preview</h2>
          <p>
            <strong>Player:</strong>{" "}
            {players.find((player) => player.id === preview.playerId)?.name}
          </p>
          <p>
            <strong>Behaviors:</strong>{" "}
            {preview.behaviorIds
              .map((id) => behaviors.find((behavior) => behavior.id === id)?.name)
              .join(", ")}
          </p>
          <p>
            <strong>Results:</strong>{" "}
            {preview.results
              .map((id) => results.find((result) => result.id === id)?.name)
              .join(", ")}
          </p>
          <p>
            <strong>Comment:</strong> {preview.comment}
          </p>
          <p>
            <strong>Created At:</strong> {preview.createdAt.toLocaleString()}
          </p>
        </div>
      )}
    </div>
  );
}
